// Tremor Raw Card [v0.0.1]
// Abweichung vom Original, abgestimmt („Feinschliff"): Radius 12px statt 10px
// — der Entwurf nennt für Karten ausdrücklich 12px. Dunkle Fläche `gray-925`
// statt `#090E1A`: Tremors Navy ist kalt und stand quer zu den warmen
// Neutralen auf Farbton 90. Die Tiefe selbst kommt aus dem Schattentoken.
//
// Abweichung, abgestimmt („randlose Karten"): Der Rahmen ist entfallen. Er war
// gemessen die tragende Kante — die Füllung unterschied sich nur um 30 (dunkel)
// beziehungsweise 32 (hell) Tausendstel Helligkeit von der Seite. Statt die
// Linie zu behalten, trägt jetzt die Fläche: `--color-flaeche` und
// `--color-flaeche-dunkel` in styles.css sind entsprechend abgesenkt, sodass
// die Karte aus der Seite steigt. Wer die Fläche wieder angleicht, muss den
// Rahmen zurückholen, sonst lösen sich die Karten auf.

import { Slot } from "@radix-ui/react-slot"
import React from "react"

import { cx } from "@/lib/utils"

interface CardProps extends React.ComponentPropsWithoutRef<"div"> {
  asChild?: boolean
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, asChild, ...props }, forwardedRef) => {
    const Component = asChild ? Slot : "div"
    return (
      <Component
        ref={forwardedRef}
        className={cx(
          // base
          "relative w-full rounded-xl p-6 text-left shadow-sm",
          // background color
          "bg-white dark:bg-gray-925",
          className,
        )}
        tremor-id="tremor-raw"
        {...props}
      />
    )
  },
)

Card.displayName = "Card"

export { Card, type CardProps }
